<template>
  <paper class="rectification-task">
    <div class="rectification-input">
      <m-search-list ref="searchList" :searchId="searchId" :list="configJson.searchList" @onSearchChange="searchFn"></m-search-list>
    </div>
    <div class="rectification-table">
    <el-table :data="tableData" border height="700" style="width: 100%">
      <el-table-column type="expand">
        <template  slot-scope="scope">
          <div class="table-expand">
            <div class="info-box" v-for="(item,index) in scope.row.monthlyAssessments" :key="index">
              <span class="table-title">{{item.quotaName}}</span>
              <span class="table-number">{{item.performanceResult}}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="整改任务单号" prop="rectificationNo" width="140"></el-table-column>
      <el-table-column label="供应商名称" prop="supplierName"></el-table-column>
      <el-table-column label="分公司" prop="companyName"></el-table-column>
      <el-table-column label="服务平台" prop="siteName"></el-table-column>
      <el-table-column label="业务大类" prop="businessCategoryText"></el-table-column>
      <el-table-column label="业务类型" prop="businessTypeText"></el-table-column>
      <el-table-column label="整改月份" prop="rectificationMonth"></el-table-column>
      <el-table-column label="KPI总评分" prop="overallRating"></el-table-column>
      <el-table-column label="任务状态" prop="taskStatusText"></el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="100">
          <template slot-scope="scope">
           <span class="tab-btn" v-has="'08030001'">
             <el-button v-if="scope.row.taskStatus==='1'||scope.row.taskStatus==='3'" size="mini" type="text" @click="workSubmit(scope.row)">提交</el-button>
           </span>
           <span class="tab-btn" v-has="'08030002'">
             <el-button v-if="scope.row.taskStatus==='2'||scope.row.taskStatus==='4'" size="mini" type="text" @click="workCheckFn(scope.row)">查看原因</el-button>
           </span>
            </template>
      </el-table-column>
    </el-table>
    </div>
    <el-pagination
      class="text-right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchInfo.pageNo"
      :page-sizes="[10, 20, 30, 50, 100]"
      :page-size="searchInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    ></el-pagination>
    <submitDialog v-if="isSubmitDialog" :isSubmitDialog.sync="isSubmitDialog" :isAction="submitAction" :row="row" @submitSuccess='submitSuccess'></submitDialog>
  </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import formatTime from '@/utils/common.js';
import submitDialog from '../components/submitDialog.vue';
import { workTaskList } from '../../../../api/achievements/rectifyApi.js';
import { dictWithUrl } from '../../../../api/dict.js';
import mSearchList from '../../../../components/searchList';
import configJson from './config.json';
import { mapState } from 'vuex';
export default {
    components: { paper, submitDialog, mSearchList },
    data() {
        return {
            configJson,
            searchId: 'searchListConfig',
            searchInfo: {
                pageNo: 1,
                pageSize: 10
            },
            totalCount: 0,
            isSubmitDialog: false, // 工作台提交弹窗
            submitAction: false, // 工作台查看
            row: '',
            dictData: {}, // 数字字典
            tableData: []
        };
    },
    computed: {
        ...mapState({ supplier: state => state.supplier })
    },
    mounted() {
        // 数字字典转换
        dictWithUrl('SRM_PERFOR_BUSINESS_CATEGORY,SRM_BUSYNESS_TYPE_BACKGROUND,SRM_PERFOR_TASK_STATUS_SU').then(res => {
            this.dictData = res.data;
            if (this.$route.query.taskStatus) { this.searchInfo.taskStatus = this.$route.query.taskStatus; }
            this.loadData();
        });
    },
    methods: {
        async loadData() {
            const res = await workTaskList({ ...this.searchInfo, supplierCode: this.supplier === undefined ? '' : this.supplier.supplierCode });
            if (res) {
                this.tableData = res.data.list;
                this.tableData = this.conversionData(this.tableData);
                this.totalCount = res.data.totalCount;
            }
        },
        conversionData(list) {
            list.map(item => {
                item.businessCategoryText = this.dictData.SRM_PERFOR_BUSINESS_CATEGORY[item.businessCategory];
                item.businessTypeText = this.dictData.SRM_BUSYNESS_TYPE_BACKGROUND[item.businessType];
                item.taskStatusText = this.dictData.SRM_PERFOR_TASK_STATUS_SU[item.taskStatus];
            });
            return list;
        },
        searchFn(data) {
            if (data.rectificationMonth && data.rectificationMonth.length > 0) {
                data.rectificationMonth = formatTime.formatDateTime(data.rectificationMonth).slice(0, 7);
            }
            this.searchInfo.pageNo = 1;
            this.searchInfo = { ...this.searchInfo, ...data };
            this.loadData();
        },
        handleSizeChange(val) {
            this.searchInfo.pageSize = val;
            this.loadData();
        },
        handleCurrentChange(val) {
            this.searchInfo.pageNo = val;
            this.loadData();
        },
        workSubmit(row) {
            this.isSubmitDialog = true;
            this.submitAction = true;
            this.row = row;
        },
        workCheckFn(row) {
            this.isSubmitDialog = true;
            this.submitAction = false;
            this.row = row;
        },
        submitSuccess() {
            this.loadData();
            this.isSubmitDialog = false;
        }
    }
};
</script>
<style lang="less">
.rectification-task {
  .rectification-input {
    margin-bottom: 15px;
  }
  .time-picker{width: 110px;}
  .table-expand {
    display: flex;
  }
  .el-table__expanded-cell{padding: 9px 0;}
  .table-title {
    font-size: 12px;
    color: #999999;
  }
  .table-number {
    margin-left: 15px;
    font-size: 12px;
    color: #333333;
  }
  .info-box {
    margin-left: 70px;
  }
  .rectification-table{
  .el-table {
    min-height: calc(~"100vh - 180px");
    max-height: calc(~"100vh - 180px");
  }
  }
  .tab-btn{
    margin-right:5px
  }
}
</style>